export const ASSISTANT_STRINGS = {
  DISCLAIMER: "5G Video Insights Assistant can make mistakes. Verify important information.",
};
